import * as Types from '../../graphql-api';

import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
export type GetVoteSmsCampaignsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetVoteSmsCampaignsQuery = { __typename?: 'Query', campaignCount?: number | null, campaign: Array<{ __typename?: 'Campaign', type?: number | null, cMessagesFailedTotal?: number | null, dlrBilling?: boolean | null, cDsErrors?: number | null, id?: number | null, name?: string | null, statusString?: string | null, messagesFailedTotal?: number | null, messagesStopList?: number | null, messagesTotal?: number | null, messagesSentTotal?: number | null, messagesRestrictedContent?: number | null, messagesFailedUnroutable?: number | null, messagesFailedInvalidNumber?: number | null, messagesFailedFiltered?: number | null, dsDelivered?: number | null, dsFiltered?: number | null, dsErrors?: number | null, startTs?: any | null, messageTemplates?: any | null, stopTs?: any | null, conversationStartReplyRate?: number | null, conversationStartReplied?: number | null, conversationWithAttention?: number | null, params?: any | null, conversationTemplate?: any | null, smsTotal?: number | null, billedAmount?: any | null, cMessagesTotal?: number | null, cMessagesSentTotal?: number | null, messagesReplied?: number | null, smsDsDelivered?: number | null, smsSent?: number | null, cSmsDsDelivered?: number | null, cSmsSent?: number | null, cSmsTotal?: number | null, smsReplied?: number | null, billedAmountRouter?: any | null, billedAmountPlatform?: any | null, cSmsFailed?: number | null, cSmsRestrictedContent?: number | null, cSmsStopList?: number | null, cSmsFailedUnroutable?: number | null, cSmsFailedInvalidNumber?: number | null, cSmsFailedFiltered?: number | null, cSmsDsErrors?: number | null, cSmsDsFiltered?: number | null, smsFailed?: number | null, smsRestrictedContent?: number | null, smsStopList?: number | null, smsFailedUnroutable?: number | null, smsFailedInvalidNumber?: number | null, smsFailedFiltered?: number | null, smsDsErrors?: number | null, smsDsFiltered?: number | null, cMessagesRestrictedContent?: number | null, cMessagesStopList?: number | null, cMessagesFailedUnroutable?: number | null, cMessagesFailedInvalidNumber?: number | null, cMessagesFailedFiltered?: number | null, cDsFiltered?: number | null, cDsDelivered?: number | null, scheduleEnabled?: boolean | null, scheduleTz?: string | null, scheduleTimes?: string | null, attachmentId?: string | null, keywords?: string | null, optInFirst?: number | null, optInSecond?: number | null, addressBookId?: number | null, createTs?: any | null, status?: { __typename?: 'CampaignStatus', name?: string | null, id?: number | null } | null, conversationTemplateId?: { __typename?: 'ConversationTemplate', name?: string | null, id?: number | null } | null, route?: { __typename?: 'Route', name?: string | null, id?: number | null } | null, replyRoute?: { __typename?: 'Route', name?: string | null, id?: number | null } | null, country?: { __typename?: 'Country', name?: string | null, id?: number | null } | null }> };


export const GetVoteSmsCampaignsDocument = gql`
    query getVoteSmsCampaigns($filter: String = null, $sort: String = null, $limit: Int = null, $offset: Int = 0) {
  campaign(filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
    type
    cMessagesFailedTotal
    dlrBilling
    cDsErrors
    id
    name
    status {
      name
      id
    }
    statusString
    messagesFailedTotal
    messagesStopList
    messagesTotal
    messagesSentTotal
    messagesRestrictedContent
    messagesFailedUnroutable
    messagesFailedInvalidNumber
    messagesFailedFiltered
    dsDelivered
    dsFiltered
    dsErrors
    startTs
    messageTemplates
    stopTs
    conversationStartReplyRate
    conversationStartReplied
    conversationWithAttention
    params
    conversationTemplate
    conversationTemplateId {
      name
      id
    }
    smsTotal
    billedAmount
    cMessagesTotal
    cMessagesSentTotal
    messagesReplied
    smsDsDelivered
    smsSent
    cSmsDsDelivered
    cSmsSent
    cSmsTotal
    smsReplied
    billedAmountRouter
    billedAmountPlatform
    cSmsFailed
    cSmsRestrictedContent
    cSmsStopList
    cSmsFailedUnroutable
    cSmsFailedInvalidNumber
    cSmsFailedFiltered
    cSmsDsErrors
    cSmsDsFiltered
    smsFailed
    smsRestrictedContent
    smsStopList
    smsFailedUnroutable
    smsFailedInvalidNumber
    smsFailedFiltered
    smsDsErrors
    smsDsFiltered
    cMessagesRestrictedContent
    cMessagesStopList
    cMessagesFailedUnroutable
    cMessagesFailedInvalidNumber
    cMessagesFailedFiltered
    cDsFiltered
    cDsDelivered
    scheduleEnabled
    scheduleTz
    scheduleTimes
    attachmentId
    route {
      name
      id
    }
    replyRoute {
      name
      id
    }
    keywords
    optInFirst
    optInSecond
    addressBookId
    createTs
    country {
      name
      id
    }
  }
  campaignCount(filter: $filter)
}
    `;
export type Requester<C = {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    getVoteSmsCampaigns(variables?: GetVoteSmsCampaignsQueryVariables, options?: C): Promise<GetVoteSmsCampaignsQuery> {
      return requester<GetVoteSmsCampaignsQuery, GetVoteSmsCampaignsQueryVariables>(GetVoteSmsCampaignsDocument, variables, options) as Promise<GetVoteSmsCampaignsQuery>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;